export default __webpack_public_path__ + "static/media/piechart.cc4cdcf1.svg";